// extracted by mini-css-extract-plugin
export var imageContainer = "ArticleContentLogo-module--image-container--1c0c4";